<div class="subtitle-style-panel">
  <div class="subtitle-style-panel__header">
    <h3 class="subtitle-style-panel__title">Subtitle style</h3>
    <button type="button" class="subtitle-style-panel__close" (click)="onClose()" aria-label="Close">&times;</button>
  </div>
  <div class="subtitle-style-panel__body">
    <div class="subtitle-style-panel__section">
      <label class="subtitle-style-panel__label subtitle-style-panel__label--with-icon">
        Font
        @if (fontLoadFailed) {
          <img
            class="subtitle-style-panel__font-error"
            [src]="fontErrorIcon"
            [title]="fontLoadErrorTitle"
            [attr.aria-label]="fontLoadErrorTitle"
            alt=""
          />
        }
      </label>
      <icn-dropdown
        class="subtitle-style-panel__dropdown"
        [selectedValue]="activeFont"
        (selectedValueChange)="onFontChange($event)"
        [position]="'bottom'"
        [medium]="true"
        [allowMultiple]="false"
        [textAlign]="'left'"
      >
        @for (f of fonts; track f) {
          <icn-dropdown-item [title]="f" [value]="f"></icn-dropdown-item>
        }
      </icn-dropdown>
    </div>
    <div class="subtitle-style-panel__section">
      <label class="subtitle-style-panel__label">Size</label>
      <icn-dropdown
        class="subtitle-style-panel__dropdown"
        [selectedValue]="fontSize"
        (selectedValueChange)="fontSize = $event"
        [position]="'bottom'"
        [medium]="true"
        [allowMultiple]="false"
        [textAlign]="'left'"
      >
        @for (s of fontSizeOptions; track s) {
          <icn-dropdown-item [title]="s + ' px'" [value]="s"></icn-dropdown-item>
        }
      </icn-dropdown>
    </div>
    <div class="subtitle-style-panel__section">
      <label class="subtitle-style-panel__label">Text color</label>
      <evrideo-clipping-studio-color-swatch-picker
        [colors]="colors"
        [value]="fontColor"
        (valueChange)="fontColor = $event"
      ></evrideo-clipping-studio-color-swatch-picker>
    </div>
    <div class="subtitle-style-panel__section">
      <label class="subtitle-style-panel__label">Background</label>
      <div class="subtitle-style-panel__position">
        <button type="button" class="subtitle-style-panel__pos-btn" [class.subtitle-style-panel__pos-btn--active]="backgroundStyle === 'solid'" (click)="backgroundStyle = 'solid'">Black box</button>
        <button type="button" class="subtitle-style-panel__pos-btn" [class.subtitle-style-panel__pos-btn--active]="backgroundStyle === 'dropShadow'" (click)="backgroundStyle = 'dropShadow'">Drop shadow</button>
      </div>
    </div>
    <div class="subtitle-style-panel__section">
      <label class="subtitle-style-panel__label">Position</label>
      <div class="subtitle-style-panel__position">
        <button type="button" class="subtitle-style-panel__pos-btn" [class.subtitle-style-panel__pos-btn--active]="position === 'top'" (click)="position = 'top'">Top</button>
        <button type="button" class="subtitle-style-panel__pos-btn" [class.subtitle-style-panel__pos-btn--active]="position === 'middle'" (click)="position = 'middle'">Middle</button>
        <button type="button" class="subtitle-style-panel__pos-btn" [class.subtitle-style-panel__pos-btn--active]="position === 'bottom'" (click)="position = 'bottom'">Bottom</button>
      </div>
    </div>
    <div class="subtitle-style-panel__section">
      <label class="subtitle-style-panel__label">Preview</label>
      <div class="subtitle-style-panel__preview" (click)="focusPreview()">
        <div class="subtitle-style-panel__preview-scroll" #previewScroll>
          <div
            #previewText
            class="subtitle-style-panel__preview-text"
            [ngStyle]="previewTextStyle"
            aria-label="Subtitle style sample"
            contenteditable="plaintext-only"
            spellcheck="false"
            role="textbox"
            (input)="onPreviewInput()"
            (focus)="onPreviewFocus()"
            (blur)="onPreviewBlur()"
            (keydown.enter)="$event.preventDefault()"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <div class="subtitle-style-panel__footer">
    <button type="button" class="subtitle-style-panel__apply" (click)="onApply()">Apply to all clips</button>
  </div>
</div>
